// extracted by mini-css-extract-plugin
export default {"header":"Header_header__6540i","image":"Header_image__Y74fm"};